import { LockOutlined, UnlockOutlined } from "@ant-design/icons";

export default function ParameterSourceToggle({ label, useCentral, onChange, disabled }: {
  label: string; useCentral: boolean; onChange: (useCentral: boolean) => void; disabled: boolean;
}) {
  return <div className="flex flex-col gap-1.5">
    <span className="text-xs text-slate-700">{label}</span>
    <button type="button" disabled={disabled} aria-pressed={useCentral} onClick={() => onChange(!useCentral)}
      aria-label={useCentral ? `ورود دستی ${label}` : `اتصال ${label} به مرکز`}
      className={`flex w-full items-center justify-between rounded-md border px-3 py-2 text-xs transition-colors focus-visible:outline-sky-600 disabled:opacity-50 ${useCentral ? "border-sky-200 bg-sky-50 text-sky-700" : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`}>
      <span>{useCentral ? "متصل به مرکز" : "مقادیر دستی"}</span>
      {useCentral ? <LockOutlined aria-hidden="true" /> : <UnlockOutlined aria-hidden="true" />}
    </button>
  </div>;
}
